import {_, React, observer, observable, computed, IDisposer, action, useLocalStore, useEffect, useLayoutEffect, classNames, useAsObservableSource, Popover2} from '@api'
import {FilterOutlined, SwapVertOutlined} from '@material-ui/icons'
import {ChangeLogClosableChip, useVipLocalStore, VipLocalStore} from '@modules'
import {StoresInstance} from '@stores'
import * as css from './ChangeLogSort.css'

/// region Store

export class ChangeLogSortStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: Omit<MyProps, 'className'>) {
    super(stores)
  }

  registerEffects = () => {
    const _toDispose: Array<IDisposer> = []

    return () => {
      _toDispose.forEach(d => d())
    }
  }

  @observable open: boolean = false

  onOpen = () => {
    this.open = true
  }

  onClose = () => {
    this.open = false
  }
}

export const ChangeLogSortStoreContext = React.createContext<ChangeLogSortStore>(null)
export const useChangeLogSortStore = () => React.useContext(ChangeLogSortStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
}

export const ChangeLogSort = observer<MyProps>(function ChangeLogSort({className, ...props}) {
  const obsProps = useAsObservableSource({...props}),
    store = useVipLocalStore((stores) => new ChangeLogSortStore(stores, obsProps)),
    {open, onOpen, onClose} = store

  useEffect(() => store.registerEffects(), [])

  return (
    <ChangeLogSortStoreContext.Provider value={store}>
      <div className={classNames(css.root, className)}>
        <Popover2
          usePortal={false}
          interactionKind={'click'}
          onOpening={onOpen}
          onClosing={onClose}
          content={<div>Sort will show up here</div>}
        >
          <ChangeLogClosableChip title={'Sort'} icon={<SwapVertOutlined/>} active={open}/>
        </Popover2>
      </div>
    </ChangeLogSortStoreContext.Provider>)
})

/// endregion




// WEBPACK FOOTER //
// ./src/modules/changelog/ChangeLogSort.tsx